import React from 'react';
import { observer } from 'mobx-react';
import { WeaSelectGroup } from 'ecCom';

@observer
export default class SelectGroupNew extends React.Component<any, any>{

    onChange = (v) => {
        const {onChange,fieldid, isChild} = this.props;
        onChange(fieldid,v,isChild);
    }

    render() {
        return <WeaSelectGroup ecId={`${this && this.props && this.props.ecId || ''}_WeaSelectGroup@2z6o4c`} 
            {...this.props}
            onChange={this.onChange}
        ></WeaSelectGroup>
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/commonComs/SelectGroupNew.tsx